import { useActiveOrg } from '../contexts/ActiveOrgContext'
import { OrgSecurityPanel } from '../components/OrgSecurityPanel'

/**
 * Security settings page at `/org/security`.
 * Shows organization status (enable/disable) and permanent deletion options.
 */
export function OrgSecurityPage() {
  const { activeOrgId, activeOrgCapabilities } = useActiveOrg()

  if (!activeOrgId) {
    return (
      <div className="mx-auto max-w-5xl px-4 py-6 md:px-6 md:py-8">
        <p className="text-pax-gray text-sm">No active organization selected.</p>
      </div>
    )
  }

  return (
    <div className="mx-auto max-w-5xl px-4 py-6 md:px-6 md:py-8">
      <OrgSecurityPanel orgId={activeOrgId} isOwner={activeOrgCapabilities.canUpdateOrg} />
    </div>
  )
}
